export default "__VITE_ASSET__0CPQZW3m__"